import {t as n, r as c, o} from '@theme/global';
import {C as a} from '@theme/cart';
import {ensureDeferredStyles} from '@theme/deferred-styles';
import '@theme/request-idle-callback';
class l extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close()),
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)),
      this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const e = document.querySelector('#cart-icon-bubble');
    e.setAttribute('role', 'button'),
      e.setAttribute('aria-haspopup', 'dialog'),
      e.addEventListener('click', (t) => {
        t.preventDefault(), this.open(e);
      }),
      e.addEventListener('keydown', (t) => {
        t.code.toUpperCase() === 'SPACE' && (t.preventDefault(), this.open(e));
      });
  }
  disconnectedCallback() {
    this.close({restoreFocus: false});
  }
  async open(e) {
    if (!this.isConnected) return;
    document.querySelector('account-drawer')?.close?.({restoreFocus: false});
    document.querySelector('wishlist-drawer')?.close?.({restoreFocus: false});
    const request = this.openRequest = (this.openRequest || 0) + 1;
    this.pendingOpenController?.abort();
    const controller = this.pendingOpenController = new AbortController();
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    }, {signal: controller.signal});
    try {
      await ensureDeferredStyles('drawer', 'cart', 'swatches');
    } catch {
      if (request === this.openRequest && this.isConnected) {
        const destination = document.querySelector('#cart-icon-bubble[href]')?.href || window.routes?.cart_url;
        if (destination) window.location.assign(destination);
      }
      return;
    } finally {
      controller.abort();
      if (this.pendingOpenController === controller) this.pendingOpenController = null;
    }
    if (request !== this.openRequest || !this.isConnected) return;
    this.drawerOpen = true;
    this.dispatchEvent(new CustomEvent('elk:cart-drawer:open', {bubbles: true}));
    e && this.setActiveElement(e);
    const t = this.querySelector('[id^="Details-"] summary');
    t && !t.hasAttribute('role') && this.setSummaryAccessibility(t),
      setTimeout(() => {
        if (request !== this.openRequest || !this.drawerOpen) return;
        this.classList.add('animate', 'active');
      }),
      this.addEventListener(
        'transitionend',
        () => {
          if (request !== this.openRequest || !this.drawerOpen) return;
          const r = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer'),
            i = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          n(r, i);
        },
        {once: !0}
      ),
      document.body.classList.add('overflow-hidden');
  }
  close({restoreFocus = true} = {}) {
    this.openRequest = (this.openRequest || 0) + 1;
    this.pendingOpenController?.abort();
    this.pendingOpenController = null;
    const wasOpen = this.drawerOpen || this.classList.contains('active');
    this.drawerOpen = false;
    if (!wasOpen) return;
    this.classList.remove('active'), c(restoreFocus ? this.activeElement : null), document.body.classList.remove('overflow-hidden');
  }
  setSummaryAccessibility(e) {
    e.setAttribute('role', 'button'),
      e.setAttribute('aria-expanded', 'false'),
      e.nextElementSibling.getAttribute('id') && e.setAttribute('aria-controls', e.nextElementSibling.id),
      e.addEventListener('click', (t) => {
        t.currentTarget.setAttribute('aria-expanded', !t.currentTarget.closest('details').hasAttribute('open'));
      }),
      e.parentElement.addEventListener('keyup', o);
  }
  renderContents(e) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty'),
      (this.productId = e.id),
      this.getSectionsToRender().forEach((t) => {
        const r = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
        r.innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector);
      }),
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)), this.open();
      });
  }
  getSectionInnerHTML(e, t = '.shopify-section') {
    return new DOMParser().parseFromString(e, 'text/html').querySelector(t).innerHTML;
  }
  getSectionsToRender() {
    return [{id: 'cart-drawer', selector: '#CartDrawer'}, {id: 'cart-icon-bubble'}];
  }
  getSectionDOM(e, t = '.shopify-section') {
    return new DOMParser().parseFromString(e, 'text/html').querySelector(t);
  }
  setActiveElement(e) {
    this.activeElement = e;
  }
}
customElements.get('cart-drawer') || customElements.define('cart-drawer', l);
class d extends a {
  getSectionsToRender() {
    return [
      {id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner'},
      {id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section'},
    ];
  }
}
customElements.get('cart-drawer-items') || customElements.define('cart-drawer-items', d);
